import React, { useState, useEffect } from "react"
import styles from "./index.module.scss"
import SecondaryButton from "../../../../../components/ui/secondary-button"
import { Autocomplete } from "@react-google-maps/api"
import axios from "axios"
import { getStore, useGet, getCookie } from "../../../../../utils/functions"
import CSRFToken from "../../../../../utils/csrftoken"
import { toast } from "react-toastify"
import { useDispatch} from "react-redux"
import { updateVehicleLocation} from "../../../../../redux/authSlice"

export default function CurrentLocationTab({ setOpenModal }) {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [searchResult, setSearchResult] = useState("")
  const [location, setLocation] = useState("");
  const [currentLocation, setCurrentLocation] = useState("")
  const { fetchedData, isLoading, fetch } = useGet("current-location/")

  const onLoad = autocomplete => {
    setSearchResult(autocomplete)
  }

  const onPlaceChanged = () => {
    if (searchResult != null) {
      const place = searchResult.getPlace()
      const name = place.name
      const status = place.business_status
      const formattedAddress = place.formatted_address
      setLocation(formattedAddress)
    } else {
      alert("Please enter text")
    }
  }

  const addLocation = e => {
    e.preventDefault()
    setLoading(true)
    axios
      .post(
        `${process.env.REACT_APP_API_URL + "add-vehicle-location/"}`,
        { address: location },
        {
          headers: {
            Authorization: `Token ${getStore("auth").token}`,
            'X-CSRFToken': getCookie('csrftoken')
          }
        }
      )
      .then(res => {
        console.log(res)
        const { address, latitude, longitude } = res.data;
        const vehicleLocation = {
          address: address,
          latitude: parseFloat(latitude),
          longitude: parseFloat(longitude)
        };
        localStorage.setItem('location', location);
        toast.success("Vehicle location added🌍🚚.")
        setLoading(false)
        dispatch(updateVehicleLocation(vehicleLocation));
        setCurrentLocation(location)
        setLocation("")
    })
  }

  useEffect(() => {
    fetch();
  }, []);

  useEffect(() => {
    if (fetchedData) {
      setCurrentLocation(fetchedData.address);
    }
  }, [fetchedData]);

  return (
    <article>
      <form onSubmit={addLocation} className="w-100">
        <CSRFToken />
        <br></br>
        <p>{currentLocation}</p>
        <br></br>
        <br></br>
        <br></br>
        <Autocomplete onPlaceChanged={onPlaceChanged} onLoad={onLoad}>
          <input
            required
            onChange={e => setLocation(e.target.value)}
            value={location}
            style={{ width: "100%" }}
            placeholder={"Enter address"}
          />
        </Autocomplete>

        <div className={styles.btns}>
          <SecondaryButton loading={loading} className="" title="submit" />
        </div>
      </form>
    </article>
  )
}
